import useApi from "@/hooks/api/useApi";

interface ResponseIpUs {
  sanctioned: boolean;
}

/**
 * @package api:internal
 */
export default function useIpOfac() {
  const { data, isLoading, isError, error, mutate } = useApi<ResponseIpUs, ResponseIpUs>(
    {
      path: `/ip/us/`,
      api: "internal",
    },
    {
      strategy: "fully-cached",
    }
  );

  return {
    data,
    isLoading,
    isError,
    error,
    mutate,
  };
}
